import { createContextForClass } from 'bz-utilities/hooks/context-v2';

import CacheStore from 'bz-utilities/modules/stores/cached-map-store';

import { computed } from 'mobx';
import { computedFn } from 'mobx-utils';

import type { Tag } from 'tm3-core/api.dtos';
import { TagEntityType } from 'tm3-core/api.dtos';

export const tagForDropdown = computedFn((tag: Tag) => {
  return {
    text: tag.name,
    payload: tag.name
  };
});

class TagsStore extends CacheStore<Tag> {
  readonly tagsByType = computedFn((types: TagEntityType[]) => {
    return this.Current.filter((t) => types.includes(t.type));
  });

  constructor() {
    super('tags');
  }

  @computed
  get Current() {
    return this.All.filter((x) => x.isActive);
  }

  @computed
  get CurrentStockTags() {
    return this.tagsByType([TagEntityType.General, TagEntityType.Stock]);
  }

  @computed
  get CurrentClientTags() {
    return this.tagsByType([TagEntityType.General, TagEntityType.Patient]);
  }

  @computed
  get CurrentClientTagsForDropdown() {
    return this.CurrentClientTags.map(tagForDropdown);
  }

  @computed
  get CurrentStockTagsForDropdown() {
    return this.CurrentStockTags.map(tagForDropdown);
  }

  @computed
  get CurrentJourneyTags() {
    return this.tagsByType([TagEntityType.General, TagEntityType.Journey]);
  }

  @computed
  get CurrentJourneyTagsForDropdown() {
    return this.CurrentJourneyTags.map(tagForDropdown);
  }

  public readonly findById = computedFn((id: string) => {
    const { _all } = this;

    return _all.get(id);
  }, {});
}

export const [TagsStoreCtx, useTagsStore] = createContextForClass(TagsStore);

export default TagsStore;
